<template>
  <div class="g-wrapper">
    <div class="g-main">
      <img src="../assets/pastTitle.png" alt="" class="u-pastTitle" />
    </div>

    <div class="g-reviewsList">
      <a :href="item.url" v-for="(item,index) in reviewList" :key="index">
        <img :src="require('../assets/'+item.year+'.png')" alt="" class="u-reviewImg" />
        <p class="u-reviewTitle">{{item.title}}</p>
      </a>
    </div>
    <img src="../assets/logo.png" alt="" class="u-logo">
  </div>
</template>

<script>
export default {
  data() {
    return {
      reviewList: [
        {
          title: "2020第九届中国上市公司高峰论坛",
          year: "2020",
          url: "http://www.nbd.com.cn/corp/2020mFenghui/index.html",
        },
        {
          title: "2019第八届中国上市公司高峰论坛",
          year: "2019",
          url: "http://www.nbd.com.cn/corp/2019mFenghui/index.html",
        },
        {
          title: "2018第七届中国上市公司高峰论坛",
          year: "2018",
          url: "http://www.nbd.com.cn/corp/2018mFenghui/index.html",
        },
        {
          title: "2017第六届中国上市公司高峰论坛",
          year: "2017",
          url: "http://www.nbd.com.cn/corp/2017fenghui-m/index.html",
        },
        {
          title: "2016第五届中国上市公司高峰论坛",
          year: "2016",
          url: "http://www.nbd.com.cn/corp/m-2016fenghui/index.html",
        },
        {
          title: "2015第四届中国上市公司高峰论坛",
          year: "2015",
          url: "http://www.nbd.com.cn/corp/2015fenghui/index.html",
        },
        {
          title: "2014第三届中国上市公司高峰论坛",
          year: "2014",
          url: "javascript:void(0)",
        },
        {
          title: "2012第二届中国上市公司高峰论坛",
          year: "2012",
          url: "http://www.nbd.com.cn/corp/2013ssgs/index.html",
        },
        {
          title: "2011第一届中国上市公司高峰论坛",
          year: "2011",
          url: "http://www.nbd.com.cn/features/178",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.g-main {
  padding-bottom: 20px;
}
.u-pastTitle {
  width: 501px;
  height: 118px;
  display: block;
  margin: 30px auto;
}
.g-reviewsList {
  width: 730px;
  padding: 55px 65px;
  box-sizing: border-box;
  background: #fff;
  margin: 0 auto;
  a {
    text-decoration: none;
    margin-bottom: 50px;
    display: block;
  }
}
.u-reviewImg {
  width: 600px;
  height: 300px;
  display: block;
}
.u-reviewTitle {
  width: 600px;
  height: 65px;
  background-image: linear-gradient(to right, #7e7e7e, #d0d0d0);
  margin-top: 5px;
  font-size: 30px;
  color: #fff;
  line-height: 65px;
  padding-left: 15px;
  box-sizing: border-box;
}
</style>